//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import SearchBar from '@components/molecules/search-bar/SearchBar';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface MediaLibrarySearchTextProps {
  isDisabled?: boolean;
  searchText: string;
  handleChangeSearchText: (value: string) => void;
}

export const MediaLibrarySearchText = ({
  handleChangeSearchText,
  isDisabled = false,
  searchText,
}: MediaLibrarySearchTextProps) => {
  return (
    <StyledSearchBar
      handleClear={() => handleChangeSearchText('')}
      isDisabled={isDisabled}
      onChange={handleChangeSearchText}
      placeholder='Quick search ...'
      trackingIdPrefix={MediaLibraryTrackingIds.SEARCH_TEXT_FILTER}
      value={searchText}
      visuallyHiddenLabel='Search for media library item'
    />
  );
};

const StyledSearchBar = styled(SearchBar)(
  ({ theme }) => `
    width: calc(${theme.spacings[7]} * 3);
  `,
);
